<template>
<div class="manager_dashboard">
  <user-menu />
  <div class="wrapper">
    <div class="content-wrapper">
      <div class="container-wrapper center">
      <div style="text-align: center;">
          <flash-message autoHide variant="success"></flash-message>
      </div>
        <div v-if="action == 'view-profile'">
        <div class="content-main-wrapper add_account_form center">
          <div class="db-card"> 
               <div class="row justify-content-lg-center justify-content-xl-center">
                <div class="col-11">
                    <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                            <div class="title">{{ pageName }}</div>
                        </div>
                        <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                            <a @click="openEditProfileForm()" class="btn btn-primary btn-sm dbEditBtn">Edit</a>
                        </div>
                    </div>
            
                    <hr class="view-mentee-hr"/>
                    <div class="row mentor_row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex justify-content-center">
                                <div class="fa fa-user-circle-o user-icon"></div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex justify-content-center">
                                <div class="db-mentor-name">Role: 
                                  <span class="roles" v-for="(option, key, index) in roles" :key="index">
                                    <span v-if="roles.length == (key+1)">{{ rolesFormatter(option) }}</span>
                                    <span v-else>{{ rolesFormatter(option) }}, </span>
                                  </span>
                                </div>
                            </div>
                        </div>
                    </div>

                  <div class="personal-details-wrapper">
                    <div class="row grid_row">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div class="title">Personal Details</div>
                      </div>
                    </div>
                    <div class="row grid_row">
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div class="label_txt">First Name: </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                            <div class="label_txt">Last Name: </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div class="label_val">{{ first_name }}</div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                            <div class="label_val">{{ last_name }}&nbsp;&nbsp;</div>
                        </div>
                    </div>
                    <div class="row grid_row">
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div class="label_txt">Email Address: </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                            <div class="label_txt">Phone Number: </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div class="label_val">{{ email }}</div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                            <div class="label_val">{{ phone_number }}&nbsp;&nbsp;</div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            </div>
          </div>

          <div class="content-main-wrapper add_account_form center">
          <div class="db-card" v-show="isUser()">
            <div class="row justify-content-lg-center justify-content-xl-center">
              <div class="col-11">
                <div class="row">
                  <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                    <div class="title">Change Password</div>
                  </div>
                  <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                      <a @click="openCPAuthModal()" class="btn btn-primary btn-sm dbEditBtn">Edit</a>
                  </div>
                </div>
                <hr class="view-mentee-hr"/> 
                <div class="row grid_row">
                  <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                    <div class="title">Password</div>
                  </div>
                  <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                    ********
                  </div>
                </div>


                <div class="row grid_row">
                  <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                    <div class="label_txt">Enable Multifactor Authentication</div>
                  </div>
                  <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                      <label class="switch" style="margin-left: 10px; padding: 0;">
                        <input type="checkbox" v-model="multifactor_authentication" @change="openAuthModal($event)" :checked="multifactor_authentication">
                        <span class="slider round"></span>
                      </label>
                  </div>
                </div>

              </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
  </div>
  <EnterpriseAdminEditProfile
    :isModalVisible="isEditProfileModalVisible"
    ref="edit_profile_form"
    @close="isEditProfileModalVisible = false">
  </EnterpriseAdminEditProfile>
  <UpdatePassword
    :isModalVisible="isUpdatePasswordModalVisible"
    ref="update_password_form"
    @close="isUpdatePasswordModalVisible = false">
  </UpdatePassword>


      <MultifactorAuthenticationConfirmModal :isModalVisible="isMultifactorAuthenticationConfirmModal"  @close="closeAuthConfirm()">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading" style="margin-left: -15px;">Enabling Multifactor Authentication</div>
        <div slot="body">
            <b-alert
              :show="dismissAuthCountDown"
              dismissible
              variant="success"
              @dismissed="dismissAuthCountDown=0"
              @dismiss-count-down="countDownAuthChanged"
              >
              {{ success_auth_message }}
            </b-alert>
            <b-alert
              :show="dismissCountWarningDown"
              dismissible
              variant="danger"
              @dismissed="dismissCountWarningDown=0"
              @dismiss-count-down="countDownWarningChanged"
              >
              {{ warning_message }}
            </b-alert>
            <div class="col-12" style="font-size: 13px; padding-bottom: 5px; margin-left: -33px;">
                Please enter the 6 digit code sent to your email.
            </div>
            <div class="col-12" style="margin-left: -8px">
                <SimpleOtpInput 
                  v-model="auth_code"
                  :inputProps="{
                    type: 'number',
                    min: 0,
                  }" 
                  @change="handleChange"/>


            </div>
            <div class="col-7 text-center" style="margin: 0px auto; margin-top: 20px; color: #00ACEE; cursor: pointer;" @click="resendCode()">
                Did not receive a code?
            </div>
          
        </div>
        <div slot="footer" class="col-12 p-0">
          <div class="col-6 float-left p-0">
            <button class="btn btn-sm ma-white-btn1" @click="closeAuthConfirm()" style="margin-left: -15px;">Cancel</button>
          </div>
          <div class="col-6 float-left p-0 text-align-right">
            <button class="btn btn-sm ma-blue-btn1" :disabled="disable_verify_btn" :class="disable_verify_btn ? 'btn-blue-disabled' : 'btn-blue'" @click="verifyCode()" style="margin-right: -23px;">Enable</button>
          </div>
          <div style="clear: both;"></div>
        </div>
      </MultifactorAuthenticationConfirmModal>

    <ChangePasswordConfirmModal :isModalVisible="isChangePasswordConfirmModal"  @close="closeCPAuthConfirm()">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading" style="margin-left: -15px;">Change Password Authenication</div>
      <div slot="body">
          <b-alert
            :show="dismissCPAuthCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCPAuthCountDown=0"
            @dismiss-count-down="countDownCPAuthChanged"
            >
            {{ success_cp_auth_message }}
          </b-alert>
          <b-alert
            :show="dismissCountCPWarningDown"
            dismissible
            variant="danger"
            @dismissed="dismissCountCPWarningDown=0"
            @dismiss-count-down="countDownCPWarningChanged"
            >
            {{ warning_cp_message }}
          </b-alert>
          <div class="col-12" style="font-size: 13px; padding-bottom: 5px; margin-left: -33px;">
              Please enter the 6 digit code sent to your email.
          </div>
          <div class="col-12" style="margin-left: -8px">
              <SimpleOtpInput 
                v-model="cp_auth_code"
                :inputProps="{
                  type: 'number',
                  min: 0,
                }" 
                @change="handleCPChange"/>


          </div>
          <div class="col-7 text-center" style="margin: 0px auto; margin-top: 20px; color: #00ACEE; cursor: pointer;" @click="resendCPCode()">
              Did not receive a code?
          </div>
        
      </div>
      <div slot="footer" class="col-12 p-0">
        <div class="col-6 float-left p-0">
          <button class="btn btn-sm ma-white-btn1" @click="closeCPAuthConfirm()" style="margin-left: -15px;">Cancel</button>
        </div>
        <div class="col-6 float-left p-0 text-align-right">
          <button class="btn btn-sm ma-blue-btn1" :disabled="disable_cp_verify_btn" :class="disable_cp_verify_btn ? 'btn-blue-disabled' : 'btn-blue'" @click="verifyCPCode()" style="margin-right: -23px;">Verify</button>
        </div>
        <div style="clear: both;"></div>
      </div>
    </ChangePasswordConfirmModal>


</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import { store } from '../../store/store';
import UserMenu from '.././shared/user_menu.vue';
import MasteradminSidebarMenu from '.././shared/masteradmin_sidebar_menu.vue';
import {ValidationMethods} from '.././shared/common_validations.js';
import AdminSidebarMenu from '.././shared/admin_sidebar_menu.vue';
import EnterpriseAdminEditProfile from './edit_profile.vue';
import UpdatePassword from '.././update_password.vue';
import SimpleOtpInput from "vue-simple-otp-input";
import 'vue-simple-otp-input/dist/vue-simple-otp-input.css';
import MultifactorAuthenticationConfirmModal from '.././admin/preference_confirm_modal.vue';
import ChangePasswordConfirmModal from '.././admin/preference_confirm_modal.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  mixins: [ValidationMethods],
  data() {
   return {
      action: 'view-profile',
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
      roles: [],
      role_options: [],
      get_url: '',
      password: '',
      confirm_password: '',
      admin_flag: false,
      email_flag: false,
      sms_flag: false,
      loading: false,
      taskListsAssigned: [],
      taskListsNames: [],
      editTaskLists: [],
      masterAdmin: false,
      admin: false,
      pageName: 'MY PROFILE',
      isEditProfileModalVisible: false,
      isUpdatePasswordModalVisible: false,
      userId: '',
      enterpriseAdmin: false,
      multifactor_authentication: false,
      isMultifactorAuthenticationConfirmModal: false,
      auth_code: '',
      dismissCountWarningDown: 0,
      warning_message: '',
      success_auth_message: '',
      dismissAuthCountDown: 0,
      disable_verify_btn: true,
      isChangePasswordConfirmModal: false,
      cp_auth_code: '',
      dismissCountCPWarningDown: 0,
      warning_cp_message: '',
      success_cp_auth_message: '',
      dismissCPAuthCountDown: 0,
      disable_cp_verify_btn: true,
    }
  },
  components: {
    SimpleOtpInput,
    UserMenu,
    MasteradminSidebarMenu,
    AdminSidebarMenu,
    EnterpriseAdminEditProfile,
    MultifactorAuthenticationConfirmModal,
    ChangePasswordConfirmModal,
    UpdatePassword,
  },
  methods: {
        handleChange(v) {
          if(v.trim().length == 6) {
            this.disable_verify_btn = false;
          } else {
            this.disable_verify_btn = true;
          }
        },
    handleCPChange(v) {
      if(v.trim().length == 6) {
        this.disable_cp_verify_btn = false;
      } else {
        this.disable_cp_verify_btn = true;
      }
    },
    countDownCPWarningChanged(dismissCountCPWarningDown) {
      this.dismissCountCPWarningDown = dismissCountCPWarningDown
    },
    countDownCPAuthChanged(dismissCPAuthCountDown) {
      this.dismissCPAuthCountDown = dismissCPAuthCountDown;
    },
    resendCPCode() {
      axios('/generate-myprofile-cp-auth-code',
      {
          method: 'GET', 
      })
      .then(response => {                
          this.success_cp_auth_message = 'Code resend successfully.';
          this.dismissCPAuthCountDown = 5;
      })
      .catch(error => {

      });
    },
    verifyCPCode() {
      if(this.cp_auth_code == '') {
        alert("Please enter the verification code");
        return false;
      }
      else if(this.cp_auth_code.length != 6) {
        alert("Verification code should be 6 digit");
        return false;
      }
      else {
        this.disable_cp_verify_btn = true;
        axios('/verify-myprofile-cp-auth-code',
        {
            method: 'POST',
            data: {
              code: this.cp_auth_code,
            }
        })
        .then(response => {  
            this.isChangePasswordConfirmModal = false;
            this.isUpdatePasswordModalVisible = true;
        })
        .catch(error => {
          this.warning_cp_message = 'Invalid verification code.';
          this.dismissCountCPWarningDown = 5;
          this.cp_auth_code = '';
        });
      }

    },
    closeCPAuthConfirm() {
      this.isChangePasswordConfirmModal = false;
      this.isUpdatePasswordModalVisible = false;
      this.$emit('close');
    },
    openCPAuthModal() {
      axios('/generate-myprofile-cp-auth-code',
      {
          method: 'GET', 
      })
      .then(response => {                
          this.isChangePasswordConfirmModal = true;
          this.isUpdatePasswordModalVisible = false;
          this.cp_auth_code = '';
      })
      .catch(error => {
      });
    },


    countDownWarningChanged(dismissCountWarningDown) {
      this.dismissCountWarningDown = dismissCountWarningDown
    },
    countDownAuthChanged(dismissAuthCountDown) {
      this.dismissAuthCountDown = dismissAuthCountDown;
    },
    resendCode() {
        axios('/generate-myprofile-auth-code',
        {
            method: 'GET', 
        })
        .then(response => {                
            this.success_auth_message = 'Code resend successfully.';
            this.dismissAuthCountDown = 5;
        })
        .catch(error => {

        });


    },
    verifyCode() {
      if(this.auth_code == '') {
        alert("Please enter the verification code");
        return false;
      }
      else if(this.auth_code.length != 6) {
        alert("Verification code should be 6 digit");
        return false;
      }
      else {
        this.disable_verify_btn = true;
        axios('/verify-myprofile-auth-code',
        {
            method: 'POST',
            data: {
              code: this.auth_code,
            }
        })
        .then(response => {  
            this.isMultifactorAuthenticationConfirmModal = false;
            this.multifactor_authentication = true;
        })
        .catch(error => {
          this.warning_message = 'Invalid verification code.';
          this.dismissCountWarningDown = 5;
          this.auth_code = '';
        });
      }

    },
    closeAuthConfirm() {
      this.isMultifactorAuthenticationConfirmModal = false;
      this.multifactor_authentication = false;
      this.$emit('close');
    },
    openAuthModal(event) {
        if(event.target.checked == true) {

          axios('/generate-myprofile-auth-code',
            {
                method: 'GET', 
            })
            .then(response => {                
                this.isMultifactorAuthenticationConfirmModal = true;
                this.multifactor_authentication = false;
            })
            .catch(error => {

            });


        }
        else {
          axios('/update-myprofile-auth-code',
            {
                method: 'POST', 
            })
            .then(response => {                
                
            })
            .catch(error => {

            });

        }
    },
    openEditProfileForm() {
      this.isEditProfileModalVisible = true;
      this.$refs.edit_profile_form.getProfileUser();
    },
    openUpdatePasswordForm() {
      this.isUpdatePasswordModalVisible = true;
    },
    isUser() {
      if(this.$route.params.user_id) {
          return false;
      }
      else {
          return true;
      }
    },
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        this.pwd_update();
      }).catch(() => {
        // catches the error;
      });
    },
    onUpdate () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        this.update();
      }).catch(() => {
        // catches the error;
      });
    },
    pwd_update: function() {
      axios('/password-update',
        {
          method: 'PATCH',
          data: {password: this.password},
        }
      )
     .then((resp) => {
       this.$store.dispatch('logout');
       this.flash({ message: 'Your password is changed. Please login.', variant: 'success' });
       this.navigate("/login");
      })
     .catch(error => {

     });
    },
    setprofile_mode(viewmode) {
      this.action = viewmode
    },
    navigate(pathUrl) {
      router.go({
        path: pathUrl,
        force: true
      });
    },
    isInArray(value, array) {
      return array.indexOf(value) > -1;
    },
    rolesFormatter(value) {
        let formattedRoles = value.replace(new RegExp('ROLE_', 'g'),'');
        formattedRoles =  formattedRoles.replace(new RegExp('_', 'g'),' ');
        return formattedRoles.toLowerCase();
    },
    
  },
  created: function() {
    var roles = this.$store.state.roles;
    if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
      this.masterAdmin = true;
    }
    if(roles.indexOf('ROLE_ENTERPRISE_ADMIN') > -1) {
      this.enterpriseAdmin = true;
    }
    this.loading = true;
    document.body.className = 'profile-page';
    this.get_url = '/enterprise-admin/my-profile';
    this.pageName = 'My Profile';
    axios(this.get_url,
      {
        method: 'POST',
      }
    )
    .then(resp => {
      this.loading = false;
      this.userId = resp.data.user.userId;
      this.first_name = resp.data.user.first_name;
      this.last_name = resp.data.user.last_name;
      this.phone_number = resp.data.user.phone_number;
      this.email = resp.data.user.email;
      this.roles = resp.data.user.roles;
      this.role_options = resp.data.roleoptions;
      this.admin_flag = resp.data.adminflag;
      this.is_mentee = resp.data.user.is_mentee;
      this.multifactor_authentication = resp.data.user.multifactor_authentication;
    })
    .catch(error => {
      this.loading = false;
    })
  },
}
</script>

<style scoped>

.db-card {
  background-color: #FFF;
  width: 100%;
  min-height: 120px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;  
}
.db-card .db-mentee-name {
  font-weight: 600;
  word-break: break-word;
}
.db-card .db-mentor-name {
  word-break: break-word;
  font-weight: 900;
}
.db-card .db-mentor-name span{
  word-break: break-word;
  font-weight: normal;
}
.grid_row {
  margin-top: 10px;
}
/* .grid_row .cols { padding: 0; } */
.db-card .label_txt {
  font-weight: 900;
  margin-bottom: 5px;
}
.saveBtn, .saveBtn:active, .saveBtn:focus {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;  
}
.container {
    max-width: 990px;
}
.dbViewBtn{
  color: #00acee !important;
  background-color: #FFF;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  width: 50px;
  float: right;
}
.dbViewBtn:focus, .dbViewBtn:active {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
}
a.dbEditBtn {
  color: #00ACEE;
  border: 0px solid #29A3E4;
  background: none;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  text-decoration: underline;
  text-align: right;
}
a.dbEditBtn {
  width: 50px;
  float: right;
  margin-top: 15px;
}
.dbEditBtn:focus,  .dbEditBtn:hover {
  color: #00acee !important;
  background:none !important;
  border: 0px solid #00acee !important;
  box-shadow: none !important;
  text-decoration: underline !important;
} 

.user-icon{ font-size: 60px;  margin-bottom: 10px; }
.mentor_row { margin: 30px; }
.db-card .title{
  font-size: 15px;
  font-weight: 900;
}
.db-card .db-report-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
.dbAddRepsBtn {
  color: #FFF;
  background-color: #00acee;
  border: 1px solid #00acee;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px;
  line-height: 10px;
  width: 100%;
  margin-top: 10px;
}
.dbAddRepsBtn:active, .dbAddRepsBtn:focus {
  color: #FFF !important;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
}
.dbGoalBtn {
  text-decoration: underline;
  color: #7d7d7d !important;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.view-mentee-hr {
    margin-top: 5px;
    margin-bottom: 0px;
    border: 1px solid #00ACEE;
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
    .statusBtn, .statusBtn:active, .statusBtn:focus {
        width: 100%;
    }
}






.comment-heading {
  padding: 12px 5px 12px 5px;
  font-size: 18px;
  color: #FFF;
  margin-top: 0px;
}
.comment-wrapper {
  padding: 5px;
  background-color: #FFF;
  width: 90%;
  min-height: 100px;
}
.task-title {
  margin: 0px 5px 5px 5px;
  border-bottom: 1px solid #DDD;
}
.task-score {
  font-weight: bold;
}
.comment-text {
  margin-top: 5px;
}
.tip:before {
  position: absolute;
  top: -14px;
  left: 98px;
  display: inline-block;
  border-right: 14px solid transparent;
  border-bottom: 14px solid #fff;
  border-left: 14px solid transparent;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  content: '';
}

.tip:after {
  position: absolute;
  top: -12px;
  left: 99px;
  display: inline-block;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #fff;
  border-left: 12px solid transparent;
  content: '';
}

.tip.left:before {
  border-top: 14px solid transparent;
  border-right: 14px solid #fff;
  border-bottom: 14px solid transparent;
  border-right-color: rgba(169, 169, 169, 1);
  left: -28px;
  top: 20px;
}

.tip.left:after {
  border-top: 12px solid transparent;
  border-right: 12px solid #fff;
  border-bottom: 12px solid transparent;
  left: -24px;
  top: 22px;
}
.tip-left {
  top: 10px;
  left: -25px;
  border-top-color: transparent;
  border-left-color: transparent;
  border-bottom-color: transparent;
}
.tip {
		background: #FFF;
		border: 2px solid #ccc;
		padding: 10px;
		position: relative;
	}
.dialogbox .body {
  position: relative;
  max-width: 300px;
  height: auto;
  margin: 20px 10px;
  padding: 5px;
  border-radius: 3px;
  border: 5px solid #ccc;
}

.body .message {
  min-height: 30px;
  border-radius: 3px;
  font-size: 14px;
  line-height: 1.5;
}
    .slide-leave-active,
    .slide-enter-active {
      transition: 0.4s;
    }
    .slide-enter {
      transform: translate(100%, 0);
    }
    .slide-leave-to {
      transform: translate(-100%, 0);
    }
.profile-page .main-wrapper {
   background-color: #FFF;
   padding: 10px;
   min-height: 400px;
   transform: none;
   margin-top:20px;
   width: 50%;
}
@media(max-width:768px) {
  .profile-page .main-wrapper {
     width: 70%;
   }
}
@media (max-width: 560px) {
 .profile-page .main-wrapper {
    border-radius: 5px;
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  .col-xs-1 {
   width: 8.33333333%;
  }
  .col-xs-11 {
    width: 91.66666667%;
  }
  .col-xs-4 {
    width: 33.333333%;
  }
  .col-xs-8 {
    width: 66.666667%;
  }
  .col-xs-9 {
    width: 75%;
  }
  .col-xs-3 {
    width: 25%;
  }
}
.content-main-wrapper h3 {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  color: #555;
}
.marginbot10 {
  margin-bottom: 10px;
}
.profile-heading {
  margin-top: 10px;
}
label {
  font-size: 12px;
}
.profile-sec-sep {
  border-top: 1px solid #DDD;
  margin: 20px 0px 20px 0px;
}
#profile-link-wrapper .profile-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}
#edit-profile-wrapper label {
  padding-left: 0px;
}
.edit-profile-wrapper .submit{
  padding-right: 15px;
  margin-top: 10px;
}
.custom-chkbox {
  width: 10%;
  float: left;
}
label.group-chkbox {
  font-weight: normal;
}
.roles { text-transform: capitalize; }
.profile-container label{
  font-weight:bold;
}
.profile-container .chkboxwrapper label{
  font-weight:normal;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 23px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.notification-wrapper .label-bold {
  padding-top: 3px;
  font-size: 12px;
  font-weight: bold !important;
}
.create_tasks_status label {
  font-weight: normal;
  font-size: 14px;
}
.edit-profile-wrapper {
  padding-top: 10px;
}
.content-main-wrapper {
  width: 75%;
  background-color: #FFF;
  padding: 30px;
  margin-bottom: 20px;
}
.personal-details-wrapper {
  padding-left: 15%;
  padding-right: 15%;   
}

.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;

}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;

}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #808080;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 2px;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #FFF;
}

input:checked + .slider {
  background-color: #4E8D23;
}
input:checked + .slider:before {
  background-color: #FFF;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* verify code css */
/deep/ .otp-single-input {
  width: 64px;
  height: 64px;
  font-size: 32px;
  border-radius: 7px;
  border: 1px solid #ced4da;
  font-weight: bold;
}
/deep/ .single-input-container {
  margin: 0px 6px;
}

/deep/ input.otp-single-input[type="number"] {
  -moz-appearance: textfield;
}

/deep/ input.otp-single-input[type="number"]::-webkit-outer-spin-button,
/deep/ input.otp-single-input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/deep/ input.otp-single-input[type="number"] {
  appearance: textfield;
}

.ma-blue-btn1 {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  border-radius: 10px;
  width: 120px;
}
.ma-white-btn1 {
  color: #00ACEE !important; 
  background-color: #FFF !important;
  border: 1px solid #00ACEE !important;
  font-weight: 900;
  border-radius: 10px;
  width: 120px;
}

</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/my_profile.vue